import {
  FETCH_SELECT_REQUEST,
  APPEND_SELECT_DATA,
  SET_SELECT_LOADING,
  RESET_SELECT_DATA,
  SEARCH_SELECT_REQUEST,
  SEARCH_SELECT_SUCCESS,
  SEARCH_SELECT_FAILURE,
  CLEAR_SEARCH_SELECT
} from './select-pagination-constants';

export const fetchSelectRequest = (resource: string, skip = 0, params?: Record<string, any>) => ({
  type: FETCH_SELECT_REQUEST,
  payload: { resource, skip, params }
});

export const appendSelectData = (resource: string, items: any[], hasMore: boolean) => ({
  type: APPEND_SELECT_DATA,
  payload: { resource, items, hasMore }
});

export const setSelectLoading = (resource: string, loading: boolean) => ({
  type: SET_SELECT_LOADING,
  payload: { resource, loading }
});

export const resetSelectData = (resource: string) => ({
  type: RESET_SELECT_DATA,
  payload: { resource }
});

export const searchSelectRequest = (resource: string, searchTerm: string, skip = 0, params?: Record<string, any>) => ({
  type: SEARCH_SELECT_REQUEST,
  payload: { resource, searchTerm, skip, params }
});

export const clearSearchSelect = (resource: string) => ({
  type: CLEAR_SEARCH_SELECT,
  payload: { resource }
});
